module.exports = __webpack_public_path__ + "img/mobuploaded.421852ec.svg";